import React from 'react';

export const QuestionnaireAdminSectionsList = ({
  sections,
  setSelectedSection,
  setShowAddQuestion,
  handleDeleteSection,
  openEditQuestion,
  handleDeleteQuestion,
}) => {
  return (
    <div className="space-y-4" data-testid="questionnaire-admin-sections-list">
      {sections.map((section, idx) => (
        <div key={section.id} className="bg-white rounded-2xl shadow-sm overflow-hidden" data-testid={`questionnaire-admin-section-card-${section.id}`}>
          <div className="p-4 border-b flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center font-bold">{idx + 1}</span>
              <div>
                <span className="font-bold text-gray-900">{section.title_jp}</span>
                <span className="text-gray-400 mx-2">/</span>
                <span className="text-green-600">{section.title_br}</span>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => {
                  setSelectedSection(section);
                  setShowAddQuestion(true);
                }}
                className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                data-testid={`questionnaire-admin-add-question-button-${section.id}`}
              >
                + Pergunta
              </button>
              <button
                onClick={() => handleDeleteSection(section.id)}
                className="px-3 py-1.5 bg-red-600 text-white rounded-lg text-sm hover:bg-red-700"
                data-testid={`questionnaire-admin-delete-section-button-${section.id}`}
              >
                🗑️
              </button>
            </div>
          </div>

          <div className="p-4 space-y-3">
            {section.questions.map((question) => (
              <div key={question.id} className="bg-gray-50 rounded-xl p-4" data-testid={`questionnaire-admin-question-card-${question.id}`}>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 bg-gray-200 text-gray-600 rounded text-xs font-medium">{question.type}</span>
                      {question.required && <span className="px-2 py-0.5 bg-red-100 text-red-600 rounded text-xs font-medium">obrigatório</span>}
                    </div>
                    <p className="text-sm"><span className="text-gray-400">JP</span> <span className="font-medium">{question.text_jp}</span></p>
                    <p className="text-sm"><span className="text-gray-400">BR</span> <span className="text-green-600">{question.text_br}</span></p>
                    {question.text_us && (
                      <p className="text-sm">
                        <span className="text-gray-400">US</span> <span className="text-gray-600">{question.text_us}</span>
                        {question.text_es && (
                          <>
                            <span className="text-gray-400 mx-1">/</span>
                            <span className="text-gray-400">ES</span> <span className="text-gray-600">{question.text_es}</span>
                          </>
                        )}
                      </p>
                    )}
                    {question.options && question.options.length > 0 && (
                      <p className="text-sm text-gray-500 mt-1"><span className="text-gray-400">Opções:</span> {question.options.join(', ')}</p>
                    )}
                  </div>
                  <div className="flex items-center gap-2 ml-4">
                    <button onClick={() => openEditQuestion(section, question)} className="text-orange-500 hover:text-orange-600 text-lg" data-testid={`questionnaire-admin-edit-question-button-${question.id}`}>
                      ✏️
                    </button>
                    <button onClick={() => handleDeleteQuestion(section.id, question.id)} className="text-gray-400 hover:text-red-500 text-lg" data-testid={`questionnaire-admin-delete-question-button-${question.id}`}>
                      🗑️
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {section.questions.length === 0 && (
              <p className="text-gray-400 text-center py-4" data-testid={`questionnaire-admin-empty-section-${section.id}`}>
                Nenhuma pergunta nesta seção. Clique em "+ Pergunta" para adicionar.
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
